export const state = () => ({
    isQuickBuyModalOpen: false,
})

export const mutations = {
    updateQuickBuyModalStatus(state, payload) {
        state.isQuickBuyModalOpen = payload
    },
}
